/* Dopekicks — Frequently Bought Together (Code Black Belt) helpers.
   1) Moves the app's widget from the footer into .dk-fbt-slot in the product info column.
   2) Syncs recommended items' size with the size the customer picked on the main product;
      if that size isn't offered for a recommended item, unticks it so a wrong size is never added.
   Does not touch discounts or the cart — BMSM (dk-bmsm.js) keeps handling those. */
(function () {
  var info = document.querySelector('.product__info-container');
  if (!info) return;
  var slot = info.querySelector('.dk-fbt-slot');
  if (!slot) {
    slot = document.createElement('div');
    slot.className = 'dk-fbt-slot';
    // Below the buy box + BMSM tiers, above "Pairs well with".
    var ref = info.querySelector('.complementary-products--wrapper') || info.querySelector('.product_additional_information');
    if (ref) info.insertBefore(slot, ref);
    else {
      var form = info.querySelector('product-form');
      var host = form && form.parentElement && form.parentElement.parentElement === info ? form.parentElement : form;
      if (host) host.insertAdjacentElement('afterend', slot); else info.appendChild(slot);
    }
  }
  var touched = new WeakSet();   // selects the customer changed by hand
  var syncing = false;

  function container() { return document.querySelector('.cbb-frequently-bought-container'); }

  // Put the item list (sizes) above the total + button: images > sizes > total > button.
  function arrange(c) {
    var list = c.querySelector('.cbb-frequently-bought-selector-list');
    var form = c.querySelector('.cbb-frequently-bought-form');
    if (list && form && form.previousElementSibling !== list) form.parentNode.insertBefore(list, form);
  }

  function move() {
    var c = container();
    if (c && c.parentElement !== slot) slot.appendChild(c);
    if (c) arrange(c);
    return c;
  }

  function mainVariantTitle() {
    var first = document.querySelector('.cbb-frequently-bought-selector-list > li select');
    var opts = [];
    document.querySelectorAll('.product__info-container variant-radios fieldset').forEach(function (f) {
      var c = f.querySelector('input:checked'); if (c) opts.push(c.value);
    });
    if (!opts.length) {
      document.querySelectorAll('.product__info-container variant-selects select').forEach(function (s) { opts.push(s.value); });
    }
    return opts.length ? opts.join(' / ') : (first && first.options[first.selectedIndex] ? first.options[first.selectedIndex].text : '');
  }

  function norm(s) { return String(s || '').toLowerCase().replace(/\s+/g, ' ').trim(); }

  function setNote(li, text) {
    var n = li.querySelector('.dk-fbt-note');
    if (!text) { if (n) n.remove(); return; }
    if (!n) { n = document.createElement('span'); n.className = 'dk-fbt-note'; li.appendChild(n); }
    n.textContent = text;
  }

  function setChecked(li, idx, on) {
    var box = li.querySelector('input[type="checkbox"]');
    if (box && box.checked !== on) box.click();      // click so the app recalculates its total
    var prod = document.querySelectorAll('.cbb-frequently-bought-products > .cbb-frequently-bought-product')[idx];
    if (prod) prod.classList.toggle('dk-fbt-off', !on);
  }

  function sync() {
    var c = container(); if (!c || syncing) return;
    var target = norm(mainVariantTitle()); if (!target) return;
    var parts = target.split(' / ');
    var size = parts[parts.length - 1];
    syncing = true;
    var items = c.querySelectorAll('.cbb-frequently-bought-selector-list > li');
    items.forEach(function (li, i) {
      var sel = li.querySelector('select'); if (!sel || touched.has(sel)) return;
      var texts = Array.prototype.map.call(sel.options, function (o) { return norm(o.text); });
      // Only sync items sized the same way (e.g. "Men's Size / 13"); leave apparel like "Black / 2XL" alone.
      var sameScheme = parts.length > 1 && texts.some(function (t) { return t.indexOf(parts[0] + ' / ') === 0; });
      if (i === 0) sameScheme = true;  // "This item" row is the main product itself
      if (!sameScheme) return;
      var hit = texts.indexOf(target);
      if (hit < 0) hit = texts.findIndex(function (t) { return t.split(' / ').pop() === size && t.indexOf(parts[0]) === 0; });
      if (hit >= 0) {
        if (sel.selectedIndex !== hit) { sel.selectedIndex = hit; sel.dispatchEvent(new Event('change', { bubbles: true })); }
        if (i > 0) { setNote(li, ''); if (li.dataset.dkAutoOff) { delete li.dataset.dkAutoOff; setChecked(li, i, true); } }
      } else if (i > 0) {
        setNote(li, 'Size ' + size.toUpperCase() + ' not available for this item');
        var box = li.querySelector('input[type="checkbox"]');
        if (box && box.checked) { li.dataset.dkAutoOff = '1'; setChecked(li, i, false); }
      }
    });
    syncing = false;
  }

  function bind(c) {
    if (!c || c.dataset.dkBound) return;
    c.dataset.dkBound = '1';
    c.addEventListener('change', function (e) {
      var t = e.target;
      if (syncing || !e.isTrusted) return;
      if (t.tagName === 'SELECT') {
        touched.add(t);
        var li = t.closest('li'); if (li) setNote(li, '');
      }
      if (t.type === 'checkbox') {
        var li2 = t.closest('li'); if (li2) delete li2.dataset.dkAutoOff;
        var idx = Array.prototype.indexOf.call(t.closest('ul').children, li2);
        var prod = document.querySelectorAll('.cbb-frequently-bought-products > .cbb-frequently-bought-product')[idx];
        if (prod) prod.classList.toggle('dk-fbt-off', !t.checked);
      }
    });
  }

  function run() { var c = move(); if (c) { bind(c); sync(); } }

  // The app renders asynchronously and may re-render; keep it in the slot.
  var mo = new MutationObserver(function () {
    var c = container();
    if (!c) return;
    if (c.parentElement !== slot) { run(); return; }
    var list = c.querySelector('.cbb-frequently-bought-selector-list');
    var form = c.querySelector('.cbb-frequently-bought-form');
    if (list && form && form.previousElementSibling !== list) arrange(c);
  });
  mo.observe(document.body, { childList: true, subtree: true });

  // Re-sync when the customer changes size on the main product.
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('.product__info-container variant-radios, .product__info-container variant-selects')) {
      setTimeout(sync, 50);
    }
  });

  run();
})();
